<template>
  <div class="scrollable">
    <v-header></v-header>
    <div class="content">
      <div
        class="nav"
        id="w1200"
      >
        <p>体检服务 > 满意度调查</p>
      </div>
      <p class="info">
        亲爱的小伙伴，欢迎参加本次满意度调查。问卷填写仅需1-2分钟，您填的所有信息均会保密，请您放心填写。
      </p>
      <p class="userInfo">
        <span>{{ detail.relativeName }}</span>
        <span>体检城市：{{ detail.areaName }}</span>
        <span>体检机构：{{ detail.branchName }}</span>
        <span>体检套餐：{{ detail.packageName }}</span>
      </p>
      <div class="scrollableBox">
        <section
          v-for="(item, index) in questionList"
          :key="index"
        >
          <div class="divText">{{ item.problemTitle }}</div>
          <div
            class="scrollableBoxXuan"
            v-if="item.problemType == 1"
          >
            <el-radio-group
              v-model="item.value"
              @change="itemClick(item)"
            >
              <el-radio
                v-model="ele.select"
                :label="ele.optionId"
                v-for="(ele, i) in item.optionVoList"
                :key="i"
              >{{ ele.optionName }}
              </el-radio>
            </el-radio-group>

            <textarea
              class="required"
              v-if="
                (item.problemId == 12 && item.value == 50) ||
                (item.problemId == 14 && item.value == 57) ||
                (item.problemId == 15 && item.value == 61) ||
                (item.problemId == 16 && item.value == 64) ||
                (item.problemId == 17 && item.value == 67) ||
                (item.problemId == 18 && item.value == 70) ||
                (item.problemId == 19 && item.value == 73)
              "
              @change="itemClick"
              @input="itemClick"
              type="textarea"
              placeholder="您不满意的原因是…（必填）"
              v-model="item.optionReason"
              maxlength="200"
              show-word-limit
            ></textarea>
          </div>
          <div
            class="scrollableBoxXuan"
            v-else-if="item.problemType == 2"
          >
            <!-- <div class="divText">请填写反馈信息：</div> -->
            <el-checkbox-group
              v-model="item.value"
              @change="itemClick"
            >
              <el-checkbox
                :label="ele.optionId"
                v-for="(ele, i) in item.optionVoList"
                :key="i"
              >{{ ele.optionName }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div
            class="scrollableBoxXuan"
            v-else
          >
            <!-- <div class="divText">请填写反馈信息：</div> -->

            <textarea
              @change="itemClick"
              type="textarea"
              placeholder="畅所欲言，关于体检的建议、评价、吐槽都可以"
              v-model="item.value"
              maxlength="200"
              show-word-limit
            ></textarea>
            <span class="limit">(限10-100字)</span>
          </div>
        </section>

        <!-- <div class="divText">请填写反馈信息：</div>
<div style="margin: 20px 0"></div>
<div class="divTextarea">
  <textarea
    type="textarea"
    placeholder="您的反馈将帮助我们更快成长"
    v-model="textarea"
    maxlength="200"
    show-word-limit
  ></textarea>
  <p class="pTextarea">( 限200字以内 )</p>
</div> -->
      </div>
      <div class="divBtn">
        <div
          :class="btn ? 'cssButton' : 'divButton'"
          @click="onButtom"
        >
          确认并提交
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import axios from "axios";
import header from "../common/header.vue";
import footer from "../common/footer.vue";
// import { examFeedback } from "../../utils/api";
import {
  surveyDetail,
  surveyUpload,
  orderDetail1
} from "../../utils/api";

export default {
  name: "",
  components: {
    "v-header": header,
    "v-footer": footer
  },

  data() {
    return {
      radio: "0",
      textarea: "",
      className: "divButton",
      questionList: [],
      list: [],
      btn: false,
      detail: {}
    };
  },
  watch: {
    questionList: {
      handler: 'btnStatus',
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true,
      deep: true
    }

  },
  created() {
    axios.get(BASE_URL + "/exam/projects/").then(res => {
      sessionStorage.setItem('project', JSON.stringify(res.data.data[0]))
    });
  },
  mounted() {
    this.getQuestionnaire();
    this.getOrderDetail();
  },
  methods: {
    // 订单详情
    async getOrderDetail() {
      this.fullscreenLoading = true;
      let subOrderNo = this.$route.query.subOrderNo;
      await orderDetail1(subOrderNo)
        .then(res => {
          this.fullscreenLoading = false;
          this.detail = res.data.data[0];
          console.log(this.detail);
        })
        .catch(err => {
          this.fullscreenLoading = false;
        });
    },
    itemClick(item) {
      if (
        (item.problemId == 12 && item.value == 50) ||
        (item.problemId == 14 && item.value == 57) ||
        (item.problemId == 15 && item.value == 61) ||
        (item.problemId == 16 && item.value == 64) ||
        (item.problemId == 17 && item.value == 67) ||
        (item.problemId == 18 && item.value == 70) ||
        (item.problemId == 19 && item.value == 73)
      ) {
        item.optionReason = "";
      } else {
        item.optionReason = undefined;
      }
      // this.btnStatus();
    },
    async onButtom() {
      if (this.btn == false) {
        return;
      }
      // let fd = new FormData();
      // fd.append("content", this.textarea);
      // fd.append("type", this.radio);
      // let config = {
      //     headers: {
      //       "access-token": localStorage.getItem("TOKEN")
      //     }
      // }
      let problemList = [];
      this.questionList.forEach(ele => {
        if (ele.problemType == 1) {
          problemList.push({
            answerVo: {
              optionId: [ele.value],
              optionName: "",
              optionReason: ele.optionReason || ""
            },
            problemId: ele.problemId,
            problemType: ele.problemType
          });
        } else if (ele.problemType == 2) {
          problemList.push({
            answerVo: {
              optionId: ele.value,
              optionName: "",
              optionReason: ""
            },
            problemId: ele.problemId,
            problemType: ele.problemType
          });
        } else {
          problemList.push({
            answerVo: {
              optionId: [],
              optionName: ele.value,
              optionReason: ""
            },
            problemId: ele.problemId,
            problemType: ele.problemType
          });
        }
      });
      let param = {
        orderId: this.$route.query.subOrderNo,
        problemList,
        projectId: JSON.parse(sessionStorage.getItem("project")).id,
        questionnaireId: 55
      };
      // console.log(param);
      axios
        .post(
          `${BASE_URL}/exam/satisfaction_survey/satisfaction/commitAnswer/`,
          param
        )
        .then(({
                 data
               }) => {
          if (data.success) {
            this.$message({
              message: data.message,
              type: "success"
            });
            // this.$router.replace("phyExServices");
          }
        });
      // await examFeedback(param).then(({ data }) => {
      //   if (data.code == 10000) {
      //     this.$message({
      //       message: '提交成功',
      //       type: "success",
      //       center: true,
      //     });
      //     this.$router.push({
      //       path: "/index",
      //     });
      //   }
      // });
      // let url = BASE_URL + '/exam/feedback/';
      // axios.post(url, {
      //     content: this.textarea,
      //     type: this.radio,
      //     headers: {
      //       "access-token": localStorage.getItem("TOKEN")
      //     }
      //   }).then((res) => {
      //     if (res.data.data == 'OK') {
      //       this.$message({
      //         message: res.data.return_msg,
      //         type: "success",
      //         center: true,
      //       });
      //       this.$router.push({
      //         path: "/index",
      //       });
      //     }
      //   })
    },
    getQuestionnaire() {
      axios
        .post(
          `${BASE_URL}/exam/satisfaction_survey/satisfaction/getQuestionnaire/`, {
            questionnaireId: 55,
            subOrderNo: this.$route.query.subOrderNo
          }
        )
        .then(({
                 data
               }) => {
          if (data.code == 10000) {
            // if (data.data.answerList.length != 0) {
            //   this.btn = false
            // } else {
            //   this.btn = true
            // }
            this.questionList = data.data.problem.problemVoList.map(ele => {
              // console.log(ele.optionReason);
              // if (ele.problemType == 1) {
              //   return { ...ele, value: this.defaultValue(item,data.data.answerList) }
              // } else if (ele.problemType == 2) {
              //   return { ...ele, value: this.defaultValue(item,data.data.answerList) }
              // } else {
              //   return { ...ele, value: this.defaultValue(item,data.data.answerList) }
              // }
              return {
                ...ele,
                value: this.defaultValue(ele, data.data.answerList),
                optionReason: this.defaultReason(ele, data.data.answerList)
              };
            });
            this.btnStatus();
            // this.userInfo = data.data;
            // this.staffInfo = data.data
          }
        });
    },
    btnStatus() {
      for (let i = 0; i < this.questionList.length; i++) {
        const ele = this.questionList[i];
        if (ele.problemType == 1) {
          if (ele.value === "" && ele.requiredFlag) {
            this.btn = false;
            return;
          } else if (
            typeof ele.optionReason == "string" &&
            ele.optionReason === ""
          ) {
            this.btn = false;
            return;
          }
        } else if (ele.problemType == 2) {
          if (ele.value.length == 0 && ele.requiredFlag) {
            this.btn = false;
            return;
          }
        } else if (ele.problemType == 3) {
          if (ele.value === "" && ele.requiredFlag) {
            this.btn = false;
            return;
          }else if(ele.value.length < 10){
            this.btn = false;
            return;
          }
        }
      }
      this.btn = true;


    },
    defaultValue(item, answerList) {
      if (answerList.length == 0) {
        if (item.problemType == 1) {
          return "";
        } else if (item.problemType == 2) {
          return [];
        } else {
          return "";
        }
      } else {
        let arr = [];
        for (let i = 0; i < answerList.length; i++) {
          const ele = answerList[i];
          if (ele.problemId == item.problemId) {
            if (item.problemType == 1) {
              return ele.optionId;
            } else if (item.problemId == 8) {
              arr.push(ele.optionId);
            } else {
              return ele.optionName;
            }
          }
        }
        return arr;
      }
    },
    defaultReason(item, answerList) {
      for (let i = 0; i < answerList.length; i++) {
        const ele = answerList[i];
        if (ele.problemId == item.problemId) {
          console.log(ele.optionReason);
          if (ele.optionReason === "") {
            return undefined;
          } else {
            return ele.optionReason;
          }
        }
      }
    },
    radioClick(item) {
      console.log(item);
    }
  }
};
</script>

<style scoped lang="scss">
$primary-color: #ff000f;
#wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content {
  width: 100%;
  height: 100%;
  // background: url("../../assets/index-bg3.png") bottom no-repeat;
}

.chart {
  width: 1000px;
  height: 740px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 17px 0px rgba(197, 197, 197, 0.35);
  position: relative;
  margin: 0 auto;

  &-topBoreder {
    width: 100%;
    height: 6px;
    background: rgba(255, 102, 51, 1);
    border-radius: 5px;
    position: absolute;
    top: -6px;
  }

  &-header {
    width: 100%;
    height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    position: relative;

    li {
      position: absolute;
      right: 17px;
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-decoration: underline;
      }
    }
  }

  &-container {
    width: 940px;
    height: 500px;
    background: rgba(242, 242, 242, 1);
    border-radius: 5px;
    margin: 0 auto;
    margin-bottom: 16px;
    overflow: auto;
  }

  &-footer {
    width: 940px;
    height: 100px;
    background: rgba(242, 242, 242, 1);
    border-radius: 5px;
    margin: 0 auto;
    display: flex;

    &-left {
      flex: 8;

      textarea {
        width: 100%;
        height: 100%;
        border: none;
        padding-top: 10px;
        padding-left: 20px;
        background: rgba(242, 242, 242, 1);
      }

      textarea::-webkit-input-placeholder {
        color: #9e9e9e;
      }
    }

    &-right {
      flex: 2;
      position: relative;

      button {
        position: absolute;
        right: 10px;
        top: 34px;
        width: 80px;
        height: 46px;
        background: rgba(255, 102, 51, 1);
        border-radius: 23px;
        line-height: 26px;
        text-align: center;
        font-size: 20px !important;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}

.info {
  width: 1180px;
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 0 30px;
  height: 82px;
  border: 1px solid #cccccc;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 82px;
}

.userInfo {
  width: 1180px;
  height: 78px;
  margin: 0 auto;
  background: #ffeeef;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 0 30px;

  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ff000f;
    line-height: 18px;
    margin-right: 50px;
  }
}

.scrollableBox {
  width: 1180px;
  // height: 504px;
  margin: 0 auto;
  border: 1px solid #ccc;
  // box-shadow: 0px 0px 30px 0px #ffefe9;
  // border-radius: 20px;
  background: #ffffff;
  padding: 30px;

  .divText {
    font-size: 18px;
    color: #333333;
    font-weight: 600;
    border-left: 4px solid #ff000f;
    padding-left: 17px;
  }

  .scrollableBoxXuan {
    position: relative;
    line-height: 78px;
    margin-left: 17px;

    .required {
      margin-top: 0;
    }

    .limit {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
      position: absolute;
      right: 15px;
      top: 50px;
    }
  }

  textarea {
    position: relative;
    height: 80px;
    width: 1120px;
    border: 1px solid #cccccc;
    padding: 25px 140px 25px 30px;
    font-size: 18px;
    margin-top: 20px;
  }

  .divTextarea {
    height: 80px;
    width: 1120px;
    position: relative;

    .pTextarea {
      position: absolute;
      width: 115px;
      color: #999999;
      font-size: 16px;
      bottom: 30px;
      right: 30px;
    }
  }
}

.divBtn {
  width: 1200px;
  height: 100px;
  margin: 15px auto 60px;

  .divButton,
  .cssButton {
    float: right;
    width: 180px;
    height: 46px;
    background: #999999;
    border-radius: 23px;
    line-height: 46px;
    text-align: center;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 20px;
    cursor: pointer;
  }

  .cssButton {
    color: #FFFFFF;
    background: #ff000f;
  }
}

.nav {
  width: 1180px;
  margin: 0 auto;
  padding: 40px 0;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/investigate.vue